module.exports = __webpack_public_path__ + "static/media/DMX.1fdd0ac5.png";